import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";
import LogoutModal from "../Navigation/LogoutModal";
import { campaignFetcher, channelFetcher } from "../../api/requests";
import { ProfileContext } from "../../context/profile";
import { useContext, useState, useEffect } from "react";

export default function MyChannels({
  mine,
  userChannels: initialUserChannels,
  header,
  admin,
  campaign = false,
}) {
  const [userChannels, setUserChannels] = useState(initialUserChannels || []);
  const [showDel, setShowDel] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    setUserChannels(initialUserChannels || []);
  }, [initialUserChannels]);

  const handleDeleteItem = (id) => {
    setShowDel(true);
    setId(id);
  };

  const handleClose = () => {
    setShowDel(false);
  };

  const handleDelete = async () => {
    try {
      const res = campaign
        ? await campaignFetcher.deleteCampaign(id)
        : await channelFetcher.delete(id);
      setUserChannels((prevChannels) =>
        prevChannels.filter((channel) => channel.id !== id)
      );
      setShowDel(false);
      window.location.reload();
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  return (
    <>
      <div
        className="video-block section-padding"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Row>
          <Col md={12}>
            <SectionHeader
              more={{
                status: userChannels?.length > 4,
                value: campaign ? "/myChannels/?campaign=true" : "/myChannels",
              }}
              heading={header}
            />
          </Col>

          {userChannels.length > 0 ? (
            userChannels.slice(0, 4).map((item, index) => (
              <Col xl={3} sm={6} className="mb-3" key={index}>
                <ChannelCard
                  total_video_count={item?.total_video_count}
                  imgSrc={campaign ? item?.banner : item?.avatar}
                  views={item?.counted_view || 0}
                  videoViews={item?.total_video_views || 0}
                  channelName={item?.name}
                  subscriberCount={item?.subscribe_count || 0}
                  mine={mine}
                  admin={admin}
                  videosId={item?.name}
                  imgHref={
                    campaign
                      ? `/single-channel/${item?.id}/?campaign=true`
                      : `/single-channel/${item?.id}`
                  }
                  channelHref={
                    campaign
                      ? `/single-channel/${item?.id}/?campaign=true`
                      : `/single-channel/${item?.id}`
                  }
                  channelId={item?.id}
                  onDelete={() => handleDeleteItem(item.id)}
                  moreAdress={`/myVideos/${item?.id}`}
                  campaign={campaign}
                  activeCampaign={item?.activation}
                />
              </Col>
            ))
          ) : (
            <p className="mr-3">{campaign ? "كمپینی" : "کانالی"} وجود ندارد.</p>
          )}
        </Row>
      </div>

      {showDel && (
        <LogoutModal
          show={showDel}
          type="delete"
          name={campaign ? "كمپین" : "کانال"}
          handleClose={handleClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
}
